import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ProductsListComponent } from './products-list/products-list.component'
import { TableModule } from 'primeng/table'
import { SharedModule } from '../shared/shared.module'
import { AutoCompleteModule } from 'primeng/autocomplete'
import { InputTextModule } from 'primeng/inputtext'
import { SelectModule } from 'primeng/select'
import { ProductPimsListComponent } from './product-pims-list/product-pims-list.component'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { ButtonModule } from 'primeng/button'
import { DialogModule } from 'primeng/dialog'
import { CheckboxModule } from 'primeng/checkbox'
import { TreeSelectModule } from 'primeng/treeselect'
import { InputGroup, InputGroupModule } from 'primeng/inputgroup'
import { InputGroupAddonModule } from 'primeng/inputgroupaddon'
import { TreeModule } from 'primeng/tree'
import { ProductsLandingComponent } from './products-landing/products-landing.component'
import { ProductsVcListComponent } from './products-vc-list/products-vc-list.component'
import { ProductsAdminListComponent } from './products-admin-list/products-admin-list.component'
import { ProductTreeSelectComponent } from './product-tree-select/product-tree-select.component'
import { TooltipModule } from 'primeng/tooltip'
import { ToggleSwitchModule } from 'primeng/toggleswitch'
import { ScrollingModule } from '@angular/cdk/scrolling'
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling'
import { OverlayPanelModule } from 'primeng/overlaypanel'
import { ProductsFeedbackComponent } from './products-feedback/products-feedback.component'
import { SelectButtonModule } from 'primeng/selectbutton'
import { InputNumberModule } from 'primeng/inputnumber'
import { MatSortModule } from '@angular/material/sort'
import { MatIconModule } from '@angular/material/icon'
import { MatTableModule } from '@angular/material/table'
import { BrowserModule } from '@angular/platform-browser'
import { ProgressBarModule } from 'primeng/progressbar'
import { MatStepperModule } from '@angular/material/stepper'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { MatOptionModule } from '@angular/material/core'

@NgModule({
   declarations: [
      ProductsListComponent,
      ProductPimsListComponent,
      ProductsLandingComponent,
      ProductsVcListComponent,
      ProductsAdminListComponent,
      ProductTreeSelectComponent,
      ProductsFeedbackComponent,
   ],
   imports: [
      CommonModule,
      SharedModule,
      AutoCompleteModule,
      ButtonModule,
      CheckboxModule,
      DialogModule,
      FormsModule,
      SelectModule,
      InputTextModule,
      InputGroupModule,
      InputGroupAddonModule,
      ToggleSwitchModule,
      TableModule,
      TreeModule,
      TreeSelectModule,
      TooltipModule,
      ScrollingModule,
      CdkVirtualScrollViewport,
      OverlayPanelModule,
      InputNumberModule,
      SelectButtonModule,
      MatSortModule,
      MatIconModule,
      MatTableModule,
      BrowserModule,
      ProgressBarModule,
      MatStepperModule,
      MatFormFieldModule,
      ReactiveFormsModule,
      MatInputModule,
	  MatAutocompleteModule,
	  MatOptionModule,
   ],
})
export class ProductsModule {}
